/** 系统设置路由 */
export default {
    name: 'system',
    path: 'system',
    meta: { title: '系统设置' },
    component: () => import('@/pages/index.vue'),
    children: [
        {
            name: 'system-information',
            path: 'information',
            meta: { title: '公司基础信息' },
            component: () => import('@/pages/system/information.vue')
        },
        {
            name: 'system-security',
            path: 'security',
            meta: { title: '窜货防伪设置' },
            component: () => import('@/pages/system/security.vue')
        },
        {
            name: 'system-account',
            path: 'account',
            meta: { title: '公众号与支付' },
            component: () => import('@/pages/system/account.vue')
        },
        {
            name: 'system-articlelist',
            path: 'articlelist',
            meta: { title: '文章列表' },
            component: () => import('@/pages/system/articlelist.vue')
        },
        {
            name: 'system-log',
            path: 'log',
            meta: { title: '操作日志' },
            component: () => import('@/pages/operationlog/index.vue')
        }
    ]
}
